var _style, _circle, _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHammer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "-10 -10 140 140",
    style: {
      enableBackground: "new 0 0 122.57 118.41"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.all{vector-effect:non-scaling-stroke;fill:#004B91;stroke:#004B91;stroke-linecap:round;stroke-miterlimit:10;stroke-width:6}\n\t.st0{fill:#FFFFFF;stroke:#FFFFFF;stroke-miterlimit:10;}\n\t.st1{fill:none;}\n\t.st3{stroke-width:1}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0 icon_status",
    cx: 58.63,
    cy: 59.04,
    r: 56.15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "all st1 icon_status",
    d: "M114.26,68.48c-4.41,26.63-27.47,46.93-55.25,46.93C28.08,115.41,3,90.25,3,59.2S28.08,3,59.01,3 c2.62,0,5.2,0.18,7.73,0.53"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0 icon_detail",
    d: "M99.97,58.35L73.79,20.96c-0.95-1.35-0.61-3.23,0.74-4.18L91.12,5.17c1.35-0.95,3.23-0.61,4.18,0.74 l26.17,37.38c0.95,1.35,0.61,3.23-0.74,4.18l-16.59,11.62C102.79,60.03,100.91,59.7,99.97,58.35z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 84.5,
    y: 17.16,
    transform: "matrix(0.8192 -0.5736 0.5736 0.8192 -0.7693 61.8096)",
    className: "all st3 icon_detail",
    width: 26.26,
    height: 29.94
  }), /*#__PURE__*/React.createElement("path", {
    className: "all st3 icon_detail",
    d: "M97.23,8.66l-2-2.86c-0.9-1.29-2.7-1.61-4-0.7L74.42,16.86c-1.29,0.9-1.61,2.7-0.7,4l2,2.86L97.23,8.66z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "all st3 icon_detail",
    d: "M121.55,43.39l-2-2.86L98.04,55.59l2,2.86c0.9,1.29,2.7,1.61,4,0.7l16.81-11.77 C122.14,46.48,122.45,44.68,121.55,43.39z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "all st3 icon_detail",
    d: "M79.54,40.59L38.77,69.14c-1.03,0.72-1.29,2.16-0.56,3.2l1.32,1.88c0.72,1.03,2.16,1.29,3.2,0.56l40.78-28.55 L79.54,40.59z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "all st3 icon_detail",
    d: "M86.31,44.26l25.56-17.9c1.03-0.72,1.29-2.16,0.56-3.2l-1.32-1.88c-0.72-1.03-2.16-1.29-3.2-0.56l-25.56,17.9 L86.31,44.26z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHammer);
export default __webpack_public_path__ + "static/media/Hammer.23ec0d9e15775d1db4540be926438c47.svg";
export { ForwardRef as ReactComponent };